import { Box, Button, Typography } from "@mui/joy";
import Add from '@mui/icons-material/Add';
import React, { useEffect, useRef, useState } from "react";
import { Dialog } from 'primereact/dialog';
import GenericTableView from "../../components/GenericTableView";
import { FilterMatchMode } from "primereact/api";
import { GenericTableColumTypes, GenericTableFilterTypes } from "../../enum/TableView";
import { v4 as uuid } from 'uuid';
import { GenericTableColumns } from "../../models/GenericTableViewModel";
import { removeClient } from "../../service/clientService";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from 'primereact/toast';
import { RouteComponentProps } from "../../models/RouteComponent";
import { removeEquipmentList } from "../../service/equipmentListService";
import { addRiskAssessment, addRiskJobStep, removeRiskAssessment, removeRiskJobStep } from "../../service/riskAssessmentService";
import TaskAdd from "./task-Add";
import DocumentDetails from "../../components/DocumentDetails";
import TaskEquipmentView from "./task-Equipment-View";
import TaskRiskAssessmentView from "./TaskRiskAssessmentView/task-Risk-Assessment-View";
import TaskFormSubmit from "./task-Form-Submit";
import TaskDocumentSign from "./task-Document-Sign";
import TaskPtoView from "./task-Pto-View";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import TaskPoliciesProcedureSign from "./task-PoliciesProcedure-Sign";
import TaskPoliciesProcedureAttendanceSign from "./task-PoliciesProcedure-Attendance-Sign";
import TaskAppointmentDocumentSign from "./task-AppointmentDocument-Sign";
import TaskMobileNote from "./task-MobileNote";
import TaskRiskAssessmentAttendanceView from "./TaskRiskAssessmentView/task-Risk-Assessment-Attendance-View";

interface TaskRecord {
  "id": string;
  "task_type": string;
  "task_reason": string;
  "importance": string;
  "due_at": string;
  "for": string;
  "name": string;
  "document_id": string;
  "employee_id": string;
  "record_id": string | number;
}

export default function TaskTable(props: RouteComponentProps) {
  const { title, subTitle, type } = useParams<{ title: string, subTitle: string, type: string }>();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get('mainCallback') === 'true') {
      localStorage.removeItem('dsf_active_site_id');
      localStorage.removeItem('dsf_active_site_name');
    }
  }, [searchParams]);

  const [selectedRecord, setRecord] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const [reloadDelay, setReloadDelay] = useState(5000); // Have to handle eventual consistency of completing a task, delay data load after they complete a task
  const toast = useRef(null as any);
  const dialog = useRef(null as any);

  const session = props.session;

  const client_id = props?.session?.client_id;

  const site = props?.session?.site_id;

  const employeeId = session.employee_id;

  const baseFilter = {

  }

  const itemSelected = (row: any) => {
    console.log("itemSelected row == ", row)
    setRecord(row.value);

    // Special handling for non-compliance tracker - redirect to dedicated page
    if (type === 'checklist_non_compliance_tracker') {
      navigate('/non-compliance');
      return;
    }

    editConfirm(row);
  }

  const contextItemSelected = (row: any) => {
    console.log("contextItemSelected row == ", row)
    setRecord(row.value);
  }

  const editConfirm = (row: any) => {
    setVisible(true);
  }

  const contextItems = () => {
    let objArray: any[] = [];
    objArray.push({ label: 'Complete Task', icon: 'pi pi-fw pi-check', command: editConfirm });
    return objArray;
  }

  const dialogItems = () => {
    switch (selectedRecord?.task_type) {
      case 'document_upload':
        return <DocumentDetails setGlobalLoading={props.setGlobalLoader} setReload={setReload} reload={reload} record={{ document: selectedRecord?.document_id }} record_id={selectedRecord?.record_id} type={getDocumentType()} setVisible={setVisible} toast={toast} />
      case 'equipment_maintenance':
      case 'equipment_replacement':
        return <TaskEquipmentView setGlobalLoading={props.setGlobalLoader} setReload={setReload} reload={reload} id={selectedRecord?.record_id} details={selectedRecord} setVisible={setVisible} toast={toast} />
      case 'risk_assessment_attendance':
        return <TaskRiskAssessmentAttendanceView setGlobalLoading={props.setGlobalLoader} setReload={setReload} reload={reload} id={selectedRecord?.record_id} details={selectedRecord} setVisible={setVisible} toast={toast} />
      case 'risk_assessment_signature':
        return <TaskRiskAssessmentView setGlobalLoading={props.setGlobalLoader} setReload={setReload} reload={reload} id={selectedRecord?.record_id} details={selectedRecord} setVisible={setVisible} toast={toast} />
      case 'form_upload':
        return <TaskFormSubmit setGlobalLoading={props.setGlobalLoader} setReload={setReload} reload={reload} id={selectedRecord?.record_id} details={selectedRecord} setVisible={setVisible} toast={toast} client_id={client_id} />
      case 'pto_employee_signature':
        return <TaskPtoView setGlobalLoading={props.setGlobalLoader} setReload={setReload} reload={reload} id={selectedRecord?.record_id} details={selectedRecord} setVisible={setVisible} toast={toast} client_id={client_id} employeeId={employeeId} />
      case 'document_signature':
        return <TaskDocumentSign setGlobalLoading={props.setGlobalLoader} setReload={setReload} reload={reload} id={selectedRecord?.record_id} details={selectedRecord} setVisible={setVisible} toast={toast} employeeId={employeeId} />
      case 'appointment_document_signature':
      case 'appointment_co_document_signature':
        return <TaskAppointmentDocumentSign setGlobalLoading={props.setGlobalLoader} setReload={setReload} reload={reload} id={selectedRecord?.id} details={selectedRecord} setVisible={setVisible} toast={toast} employeeId={employeeId} />
      case 'policy_procedure_signature':
        return <TaskPoliciesProcedureSign setGlobalLoading={props.setGlobalLoader} setReload={setReload} reload={reload} id={selectedRecord?.record_id} details={selectedRecord} setVisible={setVisible} toast={toast} employeeId={employeeId} />
      case 'policy_procedure_attendance':
        return <TaskPoliciesProcedureAttendanceSign setGlobalLoading={props.setGlobalLoader} setReload={setReload} reload={reload} id={selectedRecord?.record_id} details={selectedRecord} setVisible={setVisible} toast={toast} employeeId={employeeId} />
      default:
        return <TaskMobileNote setGlobalLoading={props.setGlobalLoader} setReload={setReload} reload={reload} id={selectedRecord?.id} details={selectedRecord} setVisible={setVisible} toast={toast} employeeId={employeeId} />
    }
  }

  const getDocumentType = () => {
    return type?.replace('document_', '');
  }


  const getDialogHeader = () => {
    return `${selectedRecord?.for || 'Task Details'} (${selectedRecord.name || selectedRecord.appointment_name})`
  }

  // Define columns based on task type
  const getColumns = (): GenericTableColumns[] => {

    switch (type) {
      case 'checklist_non_compliance_tracker':
        return [
          {
            field: 'checklist',
            header: 'Checklist',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'non_compliance_issue',
            header: 'Non-Compliance Issue',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'corrective_action',
            header: 'Corrective Action',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'raised_by',
            header: 'Raised By',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'assigned_person',
            header: 'Assigned To',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'status',
            header: 'Status',
            type: GenericTableColumTypes.Text_,
            visible: true,
          },
          {
            field: 'importance',
            header: 'Importance',
            type: GenericTableColumTypes.Importance,
            visible: true,
          },
          {
            field: 'due_date',
            header: 'Due Date',
            type: GenericTableColumTypes.Date,
            visible: true,
          }
        ];
      case 'signature_appointments':
        return [
          {
            field: 'for',
            header: 'Employee',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'type_name',
            header: 'Task',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'for_appointment_name',
            header: 'Appointment',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'appointment_name',
            header: 'As',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'site_name',
            header: 'Digital Safety File',
            type: GenericTableColumTypes.Text,
            visible: !site,
          },
          {
            field: 'due_at',
            header: 'Due Date',
            type: GenericTableColumTypes.Date,
            visible: true,
          }
        ];
      case 'signature_policies_and_procedures':
        return [
          {
            field: 'for',
            header: 'Employee',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'name',
            header: 'Policies and Procedure',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'appointment',
            header: 'Appointment',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'site_name',
            header: 'Digital Safety File',
            type: GenericTableColumTypes.Text,
            visible: !site,
          },
          {
            field: 'due_at',
            header: 'Due Date',
            type: GenericTableColumTypes.Date,
            visible: true,
          }
        ];
      case 'signature_risk_assessments':
        return [
          {
            field: 'name',
            header: 'Task',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'site_name',
            header: 'Site / Project',
            type: GenericTableColumTypes.Text,
            visible: !site,
          },
          {
            field: 'for',
            header: 'Assigned To',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'due_at',
            header: 'Due Date',
            type: GenericTableColumTypes.Date,
            visible: true,
          }
        ];
      case 'pre_site_attendance_registers':
        return [
          {
            field: 'task_type',
            header: 'Register Type',
            type: GenericTableColumTypes.Text_,
            visible: true,
          },
          {
            field: 'for',
            header: 'Assigned To',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'name',
            header: 'Document/Register Name',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'site_name',
            header: 'Site / Project',
            type: GenericTableColumTypes.Text,
            visible: !site,
          },
          {
            field: 'due_at',
            header: 'Due Date',
            type: GenericTableColumTypes.Date,
            visible: true,
          }
        ];
      case 'continuous_site_dsti':
      case 'continuous_site_toolbox_talks':
      case 'continuous_site_pto':
        return [
          {
            field: 'for',
            header: 'For',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'site_name',
            header: 'Site / Project',
            type: GenericTableColumTypes.Text,
            visible: !site,
          },
          {
            field: 'name',
            header: 'Appointment',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'due_at',
            header: 'Due Date',
            type: GenericTableColumTypes.Date,
            visible: true,
          }
        ];
      case 'checklist_tools_and_equipment':
        return [
          {
            field: 'name',
            header: 'Equipment Name',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'for',
            header: 'Responsible',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'appointment',
            header: 'Appointment',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'site_name',
            header: 'Site / Project',
            type: GenericTableColumTypes.Text,
            visible: !site,
          },
          {
            field: 'due_at',
            header: 'Due Date',
            type: GenericTableColumTypes.Date,
            visible: true,
          }
        ];
      case 'checklist_vehicles_plant':
        return [
          {
            field: 'name',
            header: 'Vehicle Name',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'for',
            header: 'Responsible',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'appointment',
            header: 'Appointment',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'site_name',
            header: 'Site / Project',
            type: GenericTableColumTypes.Text,
            visible: !site,
          },
          {
            field: 'due_at',
            header: 'Due Date',
            type: GenericTableColumTypes.Date,
            visible: true,
          }
        ];
      case 'checklist_chemicals':
        return [
          {
            field: 'name',
            header: 'Chemical Name',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'for',
            header: 'Responsible',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'appointment',
            header: 'Appointment',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'site_name',
            header: 'Site / Project',
            type: GenericTableColumTypes.Text,
            visible: !site,
          },
          {
            field: 'due_at',
            header: 'Due Date',
            type: GenericTableColumTypes.Date,
            visible: true,
          }
        ];
      case 'document_equipment':
        return [
          {
            field: 'task_type_name',
            header: 'Task',
            type: GenericTableColumTypes.Text_,
            visible: true,
          },
          {
            field: 'name',
            header: 'Document Type',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'for',
            header: 'Equipment',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'description',
            header: 'Unique ID',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'serial_number',
            header: 'Serial Number',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'importance',
            header: 'Importance',
            type: GenericTableColumTypes.Importance,
            visible: true,
          },
          {
            field: 'due_at',
            header: 'Due Date',
            type: GenericTableColumTypes.Date,
            visible: true,
          }
        ];
      case 'document_vehicle':
        return [
          {
            field: 'task_type_name',
            header: 'Task',
            type: GenericTableColumTypes.Text_,
            visible: true,
          },
          {
            field: 'name',
            header: 'Document Type',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'for',
            header: 'Vehicle',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'vin_number',
            header: 'Vin Number',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'license_number',
            header: 'License Number',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'importance',
            header: 'Importance',
            type: GenericTableColumTypes.Importance,
            visible: true,
          },
          {
            field: 'due_at',
            header: 'Due Date',
            type: GenericTableColumTypes.Date,
            visible: true,
          }
        ];
      case 'document_chemical':
        return [
          {
            field: 'task_type_name',
            header: 'Task',
            type: GenericTableColumTypes.Text_,
            visible: true,
          },
          {
            field: 'name',
            header: 'Document Type',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'for',
            header: 'Chemical',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'description',
            header: 'Description',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'importance',
            header: 'Importance',
            type: GenericTableColumTypes.Importance,
            visible: true,
          },
          {
            field: 'due_at',
            header: 'Due Date',
            type: GenericTableColumTypes.Date,
            visible: true,
          }
        ];
      default:
        return [
          {
            field: 'task_type',
            header: 'Task',
            type: GenericTableColumTypes.Text_,
            visible: true,
          },
          // {
          //   field: 'task_reason',
          //   header: 'Reason',
          //   type: GenericTableColumTypes.Text_,
          //   visible: true,
          // },
          {
            field: 'for',
            header: 'For',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'name',
            header: 'Name',
            visible: true,
            sort: false,
            type: GenericTableColumTypes.Text,
          },
          {
            field: 'importance',
            header: 'Importance',
            type: GenericTableColumTypes.Importance,
            visible: true,
          },
          {
            field: 'appointment',
            header: 'Appointment',
            type: GenericTableColumTypes.Text,
            visible: true,
          },
          {
            field: 'due_at',
            header: 'Due Date',
            type: GenericTableColumTypes.Date,
            visible: true,
          }
        ];

    }


  };

  const columns = getColumns();


  return (
    <React.Fragment>

      <Box
        sx={{
          display: "flex",
          mb: 1,
          gap: 1,
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "start", sm: "center" },
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        <Typography level="h2" component="h1">
          {title ? `${title} -> ${subTitle}` : "Action Plan For Compliance"}
        </Typography>

        {/* <Button
                  color="primary"
                  startDecorator={<Add />}
                  size="sm"
                  onClick={() => setVisible(true)}
                >Add</Button> */}
      </Box>

      <GenericTableView queryParams={{ type }} reloadDelay={reloadDelay} reload={reload} baseFilters={baseFilter} url="task-table" columns={columns} contextItems={contextItems} itemSelect={itemSelected} contextItemSelected={contextItemSelected} dataKey="unique_id" />

      <Dialog ref={dialog} header={getDialogHeader()} visible={visible} style={{ width: '80vw' }} onHide={() => { setVisible(false); }} >
        {
          dialogItems()
        }
      </Dialog>

      <ConfirmDialog />

      <Toast ref={toast} />

    </React.Fragment>
  );
}